import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connectModal } from 'redux-modal';
import PaymentCalculatorModal from '../components/views/loaded/PaymentCalculatorModal';

class PaymentCalculatorModalController extends Component {
	render() {
		const { name } = this.props;
		const CalculatorModal = connectModal({ name })(PaymentCalculatorModal);
		return <CalculatorModal />;
	}
}

PaymentCalculatorModalController.propTypes = {
	name: PropTypes.string.isRequired
};

export default PaymentCalculatorModalController;



// WEBPACK FOOTER //
// ./src/containers/PaymentCalculatorModalController.jsx